if (!customElements.get('product-buy-together-product')) {
  customElements.define('product-buy-together-product', class ProductBuyTogetherProduct extends HTMLElement {
    constructor() {
      super()
      this._onClickListener = this.handleActive.bind(this)
      this._onVariantListClickListener = this.onVariantListClick.bind(this)
      this._onVariantChangedListener = this.onVariantChanged.bind(this)
      this._onQuantityChangedListener = this.onQuantityChanged.bind(this)
      this._onToggleChangedListener = this.onToggleChanged.bind(this)
    }

    get variantListElement() {
      return this.querySelector('select[name="variant"]')
    }

    get mediaElement() {
      return this.querySelector('.row__media')
    }

    get salePriceElement() {
      return this.querySelector('.price-sale')
    }

    get comparePriceElement() {
      return this.querySelector('.price-compare')
    }

    connectedCallback() {
      this.addEventListener('click', this._onClickListener)
      this.variantListElement?.addEventListener('click', this._onVariantListClickListener)
      this.variantListElement?.addEventListener('change', this._onVariantChangedListener)
      const quantityInput = this.querySelector('input[name="fre_quantity"]')
      if (quantityInput) {
        quantityInput.value = Math.max(0, Number(quantityInput.getAttribute('value')) || 0)
        quantityInput.addEventListener('input', this._onQuantityChangedListener)
      }
      this.querySelector('[data-buy-together-minus]')?.addEventListener('click', this._onQuantityChangedListener)
      this.querySelector('[data-buy-together-plus]')?.addEventListener('click', this._onQuantityChangedListener)
      this.querySelector('[data-buy-together-toggle]')?.addEventListener('change', this._onToggleChangedListener)
      this.syncCompactSelection()
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClickListener)
      this.variantListElement?.removeEventListener('click', this._onVariantListClickListener)
      this.variantListElement?.removeEventListener('change', this._onVariantChangedListener)
      const quantityInput = this.querySelector('input[name="fre_quantity"]')
      quantityInput?.removeEventListener('input', this._onQuantityChangedListener)
      this.querySelector('[data-buy-together-minus]')?.removeEventListener('click', this._onQuantityChangedListener)
      this.querySelector('[data-buy-together-plus]')?.removeEventListener('click', this._onQuantityChangedListener)
      this.querySelector('[data-buy-together-toggle]')?.removeEventListener('change', this._onToggleChangedListener)
    }

    handleActive(e) {
      const toggleInput = this.querySelector('[data-buy-together-toggle]')
      if (toggleInput) {
        if (e.target !== toggleInput && !e.target.closest('select, a, button')) {
          toggleInput.checked = !toggleInput.checked
        }
        this.syncCompactSelection()
        return
      }

      // 点击数量输入框时不触发展开/收起
      if (e.target.name === 'fre_quantity' || e.target.closest('.buy-together-quantity')) {
        return
      }
      this.classList.toggle('active')
    }

    onToggleChanged(e) {
      e.stopPropagation()
      this.syncCompactSelection()
    }

    syncCompactSelection() {
      const toggleInput = this.querySelector('[data-buy-together-toggle]')
      const quantityInput = this.querySelector('input[name="fre_quantity"]')
      if (!toggleInput || !quantityInput) return

      quantityInput.value = toggleInput.checked ? 1 : 0
      this.classList.toggle('active', toggleInput.checked)
    }

    onQuantityChanged(e) {
      e?.stopPropagation()

      const quantityInput = this.querySelector('input[name="fre_quantity"]')
      if (!quantityInput) return

      let quantity = Number(quantityInput.value) || 0

      if (e?.target?.hasAttribute('data-buy-together-plus')) {
        quantity += 1
      }

      if (e?.target?.hasAttribute('data-buy-together-minus')) {
        quantity -= 1
      }

      quantity = Math.max(0, quantity)
      quantityInput.value = quantity

      if (quantity > 0) {
        this.classList.add('active')
      } else {
        this.classList.remove('active')
      }
    }

    onVariantListClick(e) {
      e?.stopPropagation()
    }

    onVariantChanged() {
      const option = this.variantListElement.options[this.variantListElement.selectedIndex]
      if (!option) return

      const price = option.dataset.price
      const comparePrice = option.dataset.comparePrice
      const hasComparePrice = option.hasAttribute('has-compare-price')
      const imageSrc = option.dataset.image

      // 更新图片
      if (imageSrc && this.mediaElement) {
        const oldImg = this.mediaElement.querySelector('img')
        if (oldImg) {
          const newImg = document.createElement('img')
          newImg.src = imageSrc
          newImg.alt = oldImg.alt || ''
          oldImg.replaceWith(newImg)
        }
      }

      // 更新售价
      if (price && this.salePriceElement) {
        this.salePriceElement.textContent = price
      }

      // 更新对比价：有对比价则显示并更新，无则隐藏
      if (this.comparePriceElement) {
        if (hasComparePrice && comparePrice) {
          this.comparePriceElement.textContent = comparePrice
          this.comparePriceElement.style.display = 'block'
        } else {
          this.comparePriceElement.style.display = 'none'
        }
      }
    }

    getQuantity() {
      const quantityInput = this.querySelector('input[name="fre_quantity"]')
      return quantityInput ? Math.max(0, Number(quantityInput.value) || 0) : 0
    }

    getSelectedVariantId() {
      if (!this.classList.contains('active')) {
        return null
      }
      const inputVariant = this.querySelector('input[name="variant"]')
      if (inputVariant) {
        return inputVariant.value
      }
      if (this.variantListElement) {
        const option = this.variantListElement.options[this.variantListElement.selectedIndex]
        if (option) {
          return option.value
        }
      }
      return null
    }
  })
}

if (!customElements.get('product-buy-together')) {
  customElements.define('product-buy-together', class ProductBuyTogether extends HTMLElement {
    constructor() {
      super()
    }

    getSelectedVariants() {
      const arr = []
      this.querySelectorAll('product-buy-together-product').forEach(item => {
        const id = item.getSelectedVariantId()
        const quantity = item.getQuantity()

        if (id && quantity > 0) {
          arr.push({
            id: id,
            quantity: quantity
          })
        }
      })
      return arr
    }
  })
}


if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form.querySelector('[name="id"]')) {
        this.form.querySelector('[name="id"]').disabled = false;
      }
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.buyNowButton = this.querySelector('button[name="buy-now"]');
      if (this.buyNowButton?.type === 'button') {
        this.buyNowButton.addEventListener('click', () => this.submitForm(true, this.buyNowButton));
      }
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification') || document.querySelector('cart-items');
      this.useSuccessMessage = this.cart && this.cart.tagName.toLowerCase() !== 'cart-notification';
      this.submitButton = this.querySelector('button[name="add"]');
      this.submitButtonText = this.submitButton?.querySelector('span');
      if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const actionButton = evt.submitter || this.submitButton || this.buyNowButton;
      this.submitForm(actionButton?.name === 'buy-now', actionButton);
    }

    submitForm(toCheckout, actionButton) {
      actionButton = actionButton || this.submitButton || this.buyNowButton;
      if (!actionButton || actionButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      actionButton.setAttribute('aria-disabled', true);
      actionButton.classList.add('loading');
      actionButton.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';

      const formData = new FormData(this.form);

      const productScope = this.closest('product-info') || this.closest('.shopify-section') || this
      const buyTogether = productScope.querySelector('product-buy-together')
      let extraVariants = []
      if (buyTogether) {
        extraVariants = buyTogether.getSelectedVariants() || []
      }

      if (this.cart) {
        this.cart.setActiveElement(document.activeElement);
      }

      // 若存在搭配购商品，则把主商品和搭配商品一起以 items 数组的 JSON 形式提交
      // 参考: https://shopify.dev/docs/api/ajax/reference/cart#post-locale-cart-add-js
      if (extraVariants.length > 0) {
        const mainItem = {
          id: Number(formData.get('id')),
          quantity: Number(formData.get('quantity')) || 1
        }
        // 保留主商品的 line item properties（properties[xxx]）
        const properties = {}
        for (const [key, value] of formData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/)
          if (match) {
            properties[match[1]] = value
          }
        }
        if (Object.keys(properties).length > 0) {
          mainItem.properties = properties
        }
        // 保留主商品的 selling_plan（订阅）
        const sellingPlan = formData.get('selling_plan')
        if (sellingPlan) {
          mainItem.selling_plan = Number(sellingPlan)
        }

        const items = [mainItem]
        extraVariants.forEach((variant) => {
          items.push({ id: Number(variant.id), quantity: variant.quantity })
        })

        const body = { items }
        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id).join(',')
          body.sections_url = window.location.pathname
        }

        config.headers['Content-Type'] = 'application/json'
        config.body = JSON.stringify(body)
      } else {
        // 单商品保持原有 FormData 提交方式
        delete config.headers['Content-Type'];
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
        }
        config.body = formData;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            document.dispatchEvent(new CustomEvent('afterAddCartError', {detail: {
              productVariantId: formData.get('id'),
              extraVariantIds: extraVariants.map(v => v.id),
              errors: response.errors || response.description,
              message: response.message
            }}));
            this.handleErrorMessage(response.description);
            const soldOutMessage = actionButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            actionButton.setAttribute('aria-disabled', true);
            actionButton.querySelector('span')?.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }
          if(!this.error) {
            this.error = false;
            if (toCheckout == true) {
              window.location.href = '/checkout';
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
            } else {
              if(this.useSuccessMessage) {
                pushSuccessMessage(window.cartStrings.success);
              }
  
              const quickAddDrawer = this.closest('quick-add-drawer');
              if (quickAddDrawer) {
                document.body.addEventListener('drawerClosed', () => {
                  setTimeout(() => { this.cart.renderContents(response) });
                }, { once: true });
                quickAddDrawer.close();
              } else {
                this.cart.renderContents(response);
              }
              document.dispatchEvent(new CustomEvent('afterCartChanged', {detail: {
                productVariantId: formData.get('id'),
                extraVariantIds: extraVariants.map(v => v.id),
                source: 'product-form',
                cartData: response
              }}));
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          actionButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) actionButton.removeAttribute('aria-disabled');
          actionButton.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    toggleSubmitButton(disable = true, text) {
      const actionButtons = [this.submitButton, this.buyNowButton].filter(Boolean);
      if (disable) {
        actionButtons.forEach((button) => button.setAttribute('disabled', 'disabled'));
        if (text && this.submitButtonText) this.submitButtonText.textContent = text;
      } else {
        actionButtons.forEach((button) => button.removeAttribute('disabled'));
        if(this.submitButtonText) {
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if(errorMessage && !this.errorMessageWrapper) {
        pushErrorMessage(errorMessage);
      }
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-variant-card-toggle]');
  if (!toggle) return;

  const listId = toggle.getAttribute('aria-controls');
  const list = document.getElementById(listId);
  if (!list) return;

  const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!isExpanded));
  list.classList.toggle('is-expanded', !isExpanded);
  toggle.textContent = isExpanded ? toggle.dataset.showLabel : toggle.dataset.hideLabel;
});
